<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/F3tFfp/tc-custom/9780292782457.jpg?1704828133026" alt="This image is the cover for the book Southern Journey of a Civil War Marine"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Southern Journey of a Civil War Marine
      </h1>
      <p class="bookDescription body article font2">
        <b>The confiscated Yankee diary that ran in the Confederate press, fully annotated and illustrated with drawings by a fellow Civil War Marine.</b><br/>  <br/> On September 28, 1863, the Galveston Tri-Weekly News included an item headlined “A Yankee Note-Book.” It was the first installment of a diary confiscated from U.S. Marine Henry O. Gusley, who had been captured at the Battle of Sabine Pass. It was so popular, the newspaper made an ongoing series of the entire diary, running each excerpt twice. For Confederate readers, Gusley's diary provided a rare glimpse into the opinions and feelings of an ordinary Yankee, an enemy whom—they quickly discovered—it would be easy to regard as a friend.<br/>  <br/> This book contains the complete text of Henry Gusley’s Civil War diary, expertly annotated and introduced by Edward Cotham. One of the few surviving journals by a U.S. Marine serving along the Gulf Coast, it records some of the most important naval campaigns of the Civil War, including the spectacular Union success at New Orleans and the embarrassing defeats at Galveston and Sabine Pass. It also offers an unmatched portrait of life aboard ship.<br/>  <br/> It also includes previously unpublished drawings by Daniel Nestell—a doctor who served alongside Gusley—depicting many of the events the diary describes. Together, Gusley's diary and Nestell's drawings are like picture postcards from the Civil War: vivid, literary, moving dispatches from one of “Uncle Sam's nephews in the Gulf.”
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edward T. Cotham
      </h2>
      
      <p class="authorDescription body article">Edward T. Cotham, Jr., is an independent scholar based in Houston, Texas. He is a member and past president of the Houston Civil War Roundtable, and also leads tours of Civil War battlegrounds in Texas and lectures to historical and civic groups.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?14bb45d4